// extracted by mini-css-extract-plugin
export var parcelRow = "_r6-0";